import * as React from 'react'
import styled from 'styled-components'

import Spinner from './Spinner'
import zIndex from '../../utils/zIndexScale'

const Shade = styled.div`
  /* background: ${({ theme }) => theme.exchangeSecondBg}; */
  background: transparent;
  bottom: 0;
  right: 0;
  height: 100%;
  left: 0;
  pointer-events: none;
  position: absolute;
  top: 0;
  opacity: 0;
  z-index: ${zIndex.shade};
  display: none;

  ${({ hidden }) =>
    !hidden
      ? `
    display: block;
    pointer-events: auto;
    opacity: 1;
  `
      : ''}
`

export default props => (
  <Shade {...props}>
    <Spinner />
  </Shade>
)
